import { render, staticRenderFns } from "./OutwardsGoods.vue?vue&type=template&id=ca217448&"
import script from "./OutwardsGoods.vue?vue&type=script&lang=js&"
export * from "./OutwardsGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports